var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-audit',{ref:"audit",attrs:{"audit-params":_vm.auditParams,"show-form":_vm.showForm,"only-yes":""}})}
var staticRenderFns = []

export { render, staticRenderFns }